import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";

export default function MemoryTabHabitos() {
  const { data, isLoading } = useQuery({
    queryKey: ["skills-as-habits"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("skill_registry")
        .select("id, name, description, rollout_state, version")
        .order("name");
      if (error) throw error;
      return data ?? [];
    },
  });

  if (isLoading) return <Skeleton className="h-64" />;
  const active = data?.filter(s => s.rollout_state !== "off") ?? [];

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Procedimentos que a IA executa de cor (memória procedural). Cada habilidade é um hábito treinado.
      </p>
      <Badge variant="secondary">Memória procedural: {active.length} habilidade(s) ativa(s)</Badge>
      {!data?.length ? (
        <Card><CardContent className="py-10 text-center text-muted-foreground text-sm">Nenhuma habilidade cadastrada.</CardContent></Card>
      ) : (
        <div className="grid gap-3">
          {data.map(s => (
            <Link key={s.id} to={`/skills/${s.id}`} className="block">
              <Card className="hover:border-primary transition-colors">
                <CardHeader className="pb-2">
                  <div className="flex items-center justify-between gap-3">
                    <CardTitle className="text-sm font-semibold">{s.name}</CardTitle>
                    <Badge variant={s.rollout_state === "on" ? "default" : "outline"}>{s.rollout_state}</Badge>
                  </div>
                </CardHeader>
                <CardContent className="pt-0 text-sm text-muted-foreground">
                  {s.description || "—"}
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
